export const COMMON_ACTIONS = {
    LOADING: "LOADING",
    CLEAR_CONTEXT: "CLEAR_CONTEXT"
}